import moment from 'moment-timezone';

// YYYY-MM-DD
const timestampFormat = 'YYYY-MM-DD hh:mm';
const dateFormat = 'YYYY-MM-DD';
const timestampFormatPeriod = 'YYYY-MM-DD hh:mm a';

// DD-MM-YYYY
const dateFormatDDMMYYYY = 'DD-MM-YYYY';

export const todayDate = () => {
  return moment.utc().tz('Asia/Phnom_Penh').format('YYYY-MM-DD');
};

export const todayDateInNumber = () => {
  return moment.utc().tz('Asia/Phnom_Penh').format('YYYYMMDDhhmmss');
};

export const convertTimestamp = timestamp => {
  return timestamp
    ? moment
        .utc(timestamp, timestampFormatPeriod)
        .tz('Asia/Phnom_Penh')
        .format(timestampFormatPeriod)
    : '';
};

export const convertTimestampToDate = timestamp => {
  return timestamp
    ? moment
        .utc(timestamp, timestampFormat)
        .tz('Asia/Phnom_Penh')
        .format('YYYY-MM-DD')
    : '';
};

export const convertTimestampToHumanDate = timestamp => {
  return timestamp
    ? moment
        .utc(timestamp, timestampFormat)
        .tz('Asia/Phnom_Penh')
        .format('MMMM Do , YYYY - hh:mm a')
    : '';
};

export const convertTimeDate = timestamp => {
  return timestamp
    ? moment
        .utc(timestamp, timestampFormat)
        .tz('Asia/Phnom_Penh')
        .format(dateFormat)
    : '';
};

export const convertTimeToHumanTime = timestamp => {
  return timestamp
    ? moment
        .utc(timestamp, timestampFormat)
        .tz('Asia/Phnom_Penh')
        .format('hh:mm a')
    : '';
};

export const isValidDate = date => {
  return moment.utc(date, dateFormat, true).tz('Asia/Phnom_Penh').isValid();
};

export const getDaysDifference = (from, to) => {
  if (!from || !to) return 0;
  const startDate = moment.utc(from).tz('Asia/Phnom_Penh');
  const endDate = moment.utc(to).tz('Asia/Phnom_Penh');

  return endDate.diff(startDate, 'months');
};

export const convertDateToDDMMYYFormat = date => {
  return date
    ? moment.utc(date).tz('Asia/Phnom_Penh').format(dateFormatDDMMYYYY)
    : '';
};
